<button
    mat-mini-fab
    color="primary"
    class="btn-scrolltop"
    id="btn-scrolltop"
    i18n-aria-label="@@aria-label-scrolltop"
    aria-label="back to top"
    data-testid="scrolltop"
    (click)="scrollTop()">
    <mat-icon class="riege-icon">arrow_upward</mat-icon>
</button>
